import { render, staticRenderFns } from "./ArtceramLogo.vue?vue&type=template&id=4d92aa9a&scoped=true&"
var script = {}
import style0 from "./ArtceramLogo.vue?vue&type=style&index=0&id=4d92aa9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d92aa9a",
  null
  
)

export default component.exports